import React from 'react';
import Navigation from './Navigation';
import { Outlet } from 'react-router-dom';

const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-light-gray">
      <div className="bg-white border-b border-gray-200 mb-6">
        <div className="max-w-6xl mx-auto p-4">
          <div className="brand-legal-header">
            <div className="case-badge mb-2">Mayo v. Montgomery County</div>
            <h1 className="text-3xl font-bold mb-1">Legal Case Summary & Evidence Platform</h1>
            <div className="flex items-center justify-center">
              <p className="text-sm text-gray-600">Prepared for Attorney Doug Atkinson</p>
              <span className="mx-2 text-gray-300">|</span>
              <div className="brand-veteran-accent">
                <span className="mr-1">🇺🇸</span>
                <span>Disabled Veteran - USAF</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Navigation />
      
      <main className="max-w-6xl mx-auto p-4 mt-6 mb-12">
        <Outlet />
      </main>
      
      <footer className="brand-footer">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="font-semibold">Landon J. Mayo</p>
              <p>Veteran | landonmayo722@gmail.com | (832) 510-4535</p>
            </div>
            <div className="text-sm text-gray-300">
              <p>&copy; 2025 All Rights Reserved</p>
              <p>Last Updated: April 24, 2025</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AdminLayout;